import { createClient } from '@supabase/supabase-js'

let _client = null

export function getSupabase() {
  if (_client) return _client
  const url  = process.env.REACT_APP_SUPABASE_URL
  const anon = process.env.REACT_APP_SUPABASE_ANON_KEY
  if (!url || !anon) return null
  _client = createClient(url, anon, { auth: { flowType: 'implicit' } })
  return _client
}
